import { useId } from "react";

// Numeric input that stores a STRING while editing: backspace can empty it,
// nothing snaps back to 0, validation happens only on submit (via `error`).
export const sanitizeNumeric = (raw, { decimal = false } = {}) => {
  let v = (raw || "").replace(decimal ? /[^0-9.]/g : /\D/g, "");
  if (decimal) {
    const [a, ...rest] = v.split(".");
    v = rest.length ? `${a}.${rest.join("").slice(0, 1)}` : a;
  }
  v = v.replace(/^0+(?=\d)/, "");
  return v;
};

export const validateNumeric = (value, { required = true, min, max, label = "This field", lang = "en" } = {}) => {
  const es = lang === "es";
  if (value === "" || value == null) return required ? (es ? `${label} es obligatorio.` : `${label} is required.`) : "";
  const n = Number(value);
  if (Number.isNaN(n)) return es ? "Ingrese un número." : "Enter a number.";
  if (min != null && n < min) return es ? `${label} debe ser al menos ${min}.` : `${label} must be at least ${min}.`;
  if (max != null && n > max) return es ? `${label} no puede superar ${max}.` : `${label} cannot exceed ${max}.`;
  return "";
};

export const NumberField = ({ id, label, value, onChange, decimal = false, error = "", testId, placeholder = "" }) => {
  const autoId = useId();
  const inputId = id || autoId;
  return (
    <div>
      <label className="block text-sm font-semibold mb-1" htmlFor={inputId}>{label}</label>
      <input
        id={inputId}
        type="text"
        inputMode={decimal ? "decimal" : "numeric"}
        autoComplete="off"
        enterKeyHint="next"
        value={value}
        placeholder={placeholder}
        onFocus={(e) => e.target.select()}
        onChange={(e) => onChange(sanitizeNumeric(e.target.value, { decimal }))}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-err` : undefined}
        className={`w-full border rounded-md px-3 py-3 text-base min-h-[48px] bg-white ${error ? "border-red-500" : "border-slate-300"}`}
        data-testid={testId}
      />
      {error && <div id={`${inputId}-err`} role="alert" className="mt-1 text-xs text-red-700" data-testid={`${testId}-error`}>{error}</div>}
    </div>
  );
};
